import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "drawer"]

  connect() {
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.hasPanelTarget && !this.panelTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  open() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("hidden")
    }
    document.body.style.overflow = "hidden"
  }

  close() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("hidden")
    }
    document.body.style.overflow = ""
  }

  toggle() {
    if (this.hasPanelTarget && this.panelTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }
}
